var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "feed grid grid__base" }, [
      _c("div", { staticClass: "grid--container" }, [
        _c("iframe", {
          staticClass: "feed--iframe",
          attrs: {
            "data-cookiebot-src": "https://feed.mikle.com/widget/v2/84767/",
            "data-cookieconsent": "marketing",
            height: "616px",
            scrolling: "no",
            frameborder: "0"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f00818d0", { render: render, staticRenderFns: staticRenderFns })
  }
}